// src/api/index.js
import request from '@/utils/request'

function serializeParams(params) {
  const search = new URLSearchParams()
  Object.keys(params || {}).forEach((key) => {
    const val = params[key]
    if (val === undefined || val === null || val === '') return
    if (Array.isArray(val)) {
      val.forEach((item) => {
        if (item !== undefined && item !== null && item !== '') {
          search.append(key, item)
        }
      })
      return
    }
    search.append(key, val)
  })
  return search.toString()
}

// 用户管理相关API
export const userApi = {
  // 获取用户列表
  getUserList(params) {
    return request({
      url: '/api/v1/admin/users',
      method: 'get',
      params,
      paramsSerializer: serializeParams
    })
  },
  
  // 创建用户
  createUser(data) {
    return request({
      url: '/api/v1/admin/users',
      method: 'post',
      data
    })
  },
  
  // 更新用户
  updateUser(id, data) {
    return request({
      url: `/api/v1/admin/users/${id}`,
      method: 'put',
      data
    })
  },
  
  // 删除用户
  deleteUser(id) {
    return request({
      url: `/api/v1/admin/users/${id}`,
      method: 'delete'
    })
  },
  
  // 更新用户状态
  updateUserStatus(id, data) {
    return request({
      url: `/api/v1/admin/users/${id}/status`,
      method: 'put',
      data
    })
  },
  
  // 重置用户密码
  resetUserPassword(id) {
    return request({
      url: `/api/v1/admin/users/${id}/password`,
      method: 'put'
    })
  },

  // 管理员为用户添加余额（秒）
  // body: { seconds, memo } → AdminAddBalanceDTO
  addBalance(userId, data) {
    return request({
      url: `/api/v1/admin/users/${userId}/balance`,
      method: 'post',
      data
    })
  },

  // 导出用户数据（按筛选条件）
  exportUsers(params) {
    return request({
      url: '/api/v1/admin/users/export',
      method: 'get',
      params,
      paramsSerializer: serializeParams,
      responseType: 'blob',
      timeout: 60000
    })
  },
  //获取车辆认证信息
  getUserVehicleCertInfo(params){
    return request({
      url: '/api/v1/admin/users/certificationDetail',
      method: 'get',
      params
    })
  },
  //修改认证状态
  changeCertStatus(data) {
    return request({
      url: `/api/v1/admin/users/changeCertification`,
      method: 'put',
      data
    })
  },


}

export const invitePartnerApi = {
  getList(params) {
    return request({
      url: '/api/v1/admin/partners',
      method: 'get',
      params
    })
  },
  getById(id) {
    return request({
      url: `/api/v1/admin/partners/${id}`,
      method: 'get'
    })
  },
  create(data) {
    return request({
      url: '/api/v1/admin/partners',
      method: 'post',
      data
    })
  },
  update(id, data) {
    return request({
      url: `/api/v1/admin/partners/${id}`,
      method: 'put',
      data
    })
  },
  updateStatus(id, data) {
    return request({
      url: `/api/v1/admin/partners/${id}/status`,
      method: 'put',
      data
    })
  },
  remove(id) {
    return request({
      url: `/api/v1/admin/partners/${id}`,
      method: 'delete'
    })
  }
}

// 管理员账户管理相关API
export const adminUserApi = {
  // 获取管理员账户列表
  getAdminUserList(params) {
    return request({
      url: '/api/v1/admin/admin-users',
      method: 'get',
      params
    })
  },
  
  // 获取管理员账户详情
  getAdminUserById(id) {
    return request({
      url: `/api/v1/admin/admin-users/${id}`,
      method: 'get'
    })
  },

  // 创建管理员账户
  createAdminUser(data) {
    return request({
      url: '/api/v1/admin/admin-users',
      method: 'post',
      data
    })
  },
  
  // 更新管理员账户
  updateAdminUser(id, data) {
    return request({
      url: `/api/v1/admin/admin-users/${id}`,
      method: 'put',
      data
    })
  },
  
  // 删除管理员账户
  deleteAdminUser(id) {
    return request({
      url: `/api/v1/admin/admin-users/${id}`,
      method: 'delete'
    })
  },
  
  // 更新管理员账户状态
  updateAdminUserStatus(id, data) {
    return request({
      url: `/api/v1/admin/admin-users/${id}/status`,
      method: 'put',
      data
    })
  },
  
  // 重置管理员账户密码
  resetAdminUserPassword(id, data) {
    return request({
      url: `/api/v1/admin/admin-users/${id}/password`,
      method: 'put',
      data
    })
  },
  
  // 修改当前登录用户密码
  updateCurrentPassword(data) {
    return request({
      url: '/api/v1/admin/admin-users/current/password',
      method: 'put',
      data
    })
  }
}

// 设备管理相关API
export const deviceApi = {
  getFwVersions() {
    return request({
      url: '/api/v1/admin/devices/fw-versions',
      method: 'get'
    })
  },
  // 获取设备列表
  getDeviceList(params) {
    return request({
      url: '/api/v1/admin/devices',
      method: 'get',
      params,
      paramsSerializer: serializeParams
    })
  },
  
  // 获取设备详情
  getDeviceDetail(deviceId) {
    return request({
      url: `/api/v1/admin/devices/${deviceId}`,
      method: 'get'
    })
  },

  // 创建设备
  createDevice(data) {
    return request({
      url: '/api/v1/admin/devices',
      method: 'post',
      data
    })
  },
  
  // 更新设备
  updateDevice(id, data) {
    return request({
      url: `/api/v1/admin/devices/${id}`,
      method: 'put',
      data
    })
  },
  
  // 删除设备
  deleteDevice(id) {
    return request({
      url: `/api/v1/admin/devices/${id}`,
      method: 'delete'
    })
  },
  
  // 更新设备状态（设备下线）
  updateDeviceStatus(deviceId, data) {
    return request({
      url: `/api/v1/admin/devices/${deviceId}/offline`,
      method: 'post',
      data
    })
  },

  // 设备上线
  onlineDevice(deviceId) {
    return request({
      url: `/api/v1/admin/devices/${deviceId}/online`,
      method: 'post'
    })
  },
  
  // 获取设备日志
  getDeviceLogs(id, params) {
    return request({
      url: `/api/v1/admin/devices/${id}/logs`,
      method: 'get',
      params
    })
  },
  
  // 更换运维人员
  changeMaintainer(id, data) {
    return request({
      url: `/api/v1/admin/devices/${id}/maintainer`,
      method: 'put',
      data
    })
  },

  // 导出设备列表（后端待提供，沿用列表全部筛选参数）
  exportDevices(params) {
    return request({
      url: '/api/v1/admin/devices/export',
      method: 'get',
      params,
      paramsSerializer: serializeParams,
      responseType: 'blob',
      timeout: 60000
    })
  }
}

// 质检记录相关API
export const qcRecordApi = {
  getQcRecordList(params) {
    return request({
      url: '/api/v1/admin/device-inspections',
      method: 'get',
      params
    })
  }
}

// 订单管理相关API
export const orderApi = {
  // 获取订单列表
  getOrderList(params) {
    return request({
      url: '/api/v1/admin/orders/list',
      method: 'get',
      params,
      paramsSerializer: serializeParams
    })
  },
  
  // 获取订单详情
  getOrderDetail(id) {
    return request({
      url: `/api/v1/admin/orders/${id}`,
      method: 'get'
    })
  },
  
  // 更新订单状态
  updateOrderStatus(id, data) {
    return request({
      url: `/api/v1/admin/orders/${id}/status`,
      method: 'put',
      data
    })
  },
  
  // 退回订单
  // refundMode: FULL-全额退款（默认），BY_REMAINING_DURATION-按剩余可用时长折算（仅充值订单）
  refundOrder(orderNo, reason, refundMode) {
    return request({
      url: `/api/v1/admin/orders/${orderNo}/refund`,
      method: 'post',
      params: {
        reason,
        refundMode: refundMode || undefined
      }
    })
  },

  // 导出一级订单（按筛选条件）
  exportOrders(params) {
    return request({
      url: '/api/v1/admin/orders/export',
      method: 'get',
      params,
      paramsSerializer: serializeParams,
      responseType: 'blob',
      timeout: 60000
    })
  },

  // 导出明细订单（启动订单子单，筛选条件与列表一致）
  // GET /api/v1/admin/orders/orderItem/export  permission: order:item:export
  exportOrderItems(params) {
    return request({
      url: '/api/v1/admin/orders/orderItem/export',
      method: 'get',
      params,
      responseType: 'blob',
      timeout: 60000
    })
  }
}

// 运营商订单管理 — 对齐 /api/v1/admin/bizoperator/orders
export const bizOperatorOrderApi = {
  // GET /api/v1/admin/bizoperator/orders/list
  getList(params) {
    return request({
      url: '/api/v1/admin/bizoperator/orders/list',
      method: 'get',
      params
    })
  },

  // GET /api/v1/admin/bizoperator/orders/export
  exportOrders(params) {
    return request({
      url: '/api/v1/admin/bizoperator/orders/export',
      method: 'get',
      params,
      responseType: 'blob',
      timeout: 60000
    })
  }
}

// 角色管理相关API
export const roleApi = {
  // 新版角色列表（包含角色权限树）
  getNewRoleList() {
    return request({
      url: '/api/v1/admin/new/role/list',
      method: 'get'
    })
  },

  // 新版权限树
  getPermissionTree() {
    return request({
      url: '/api/v1/admin/permission/list',
      method: 'get'
    })
  },

  // 新版新增角色
  createNewRole(name) {
    return request({
      url: '/api/v1/admin/new/role',
      method: 'post',
      data: { name }
    })
  },

  // 新版角色重命名
  updateNewRole(id, name) {
    return request({
      url: '/api/v1/admin/new/role',
      method: 'put',
      data: { id, name }
    })
  },

  // 新版删除角色
  deleteNewRole(id) {
    return request({
      url: `/api/v1/admin/new/role/${id}`,
      method: 'delete'
    })
  },

  // 保存角色权限
  saveRolePermissions(roleId, permissionIds) {
    return request({
      url: '/api/v1/admin/new/role/addPermission',
      method: 'post',
      data: {
        roleId,
        permissionIds
      }
    })
  },

  // 获取角色列表
  getRoleList() {
    return request({
      url: '/api/v1/admin/roles',
      method: 'get'
    })
  },
  
  // 获取角色选项
  getRoleOptions() {
    return request({
      url: '/api/v1/admin/roles/options',
      method: 'get'
    })
  },
  
  // 创建角色
  createRole(data) {
    return request({
      url: '/api/v1/admin/roles',
      method: 'post',
      data
    })
  },
  
  // 更新角色
  updateRole(id, data) {
    return request({
      url: `/api/v1/admin/roles/${id}`,
      method: 'put',
      data
    })
  },
  
  // 删除角色
  deleteRole(id) {
    return request({
      url: `/api/v1/admin/roles/${id}`,
      method: 'delete'
    })
  }
}

// 运营设置相关API - 对应定价方案
export const operationApi = {
  // 获取运营设置列表
  // packageType: SALE_RATE | EXTRA_BONUS
  // isHomepagePopup: 0 | 1
  // enabled: true | false
  getOperationList(params) {
    return request({
      url: '/api/v1/admin/pricing-rules',
      method: 'get',
      params
    })
  },
  
  // 创建运营设置
  createOperation(data) {
    return request({
      url: '/api/v1/admin/pricing-rules',
      method: 'post',
      data
    })
  },
  
  // 更新运营设置
  updateOperation(id, data) {
    return request({
      url: `/api/v1/admin/pricing-rules/${id}`,
      method: 'put',
      data
    })
  },
  
  // 删除运营设置
  deleteOperation(id) {
    return request({
      url: `/api/v1/admin/pricing-rules/${id}`,
      method: 'delete'
    })
  },
  
  // 更新运营设置状态
  updateOperationStatus(id, data) {
    return request({
      url: `/api/v1/admin/pricing-rules/${id}/status`,
      method: 'put',
      data
    })
  },

  // 切换首页弹窗：query enabled=true|false
  updateOperationPopup(id, enabled) {
    return request({
      url: `/api/v1/admin/pricing-rules/${id}/popup`,
      method: 'put',
      params: {enabled}
    })
  },

  // 切换首页展示：query enabled=true|false（最多同时开启4个）
  updateHomepageDisplay(id, enabled) {
    return request({
      url: `/api/v1/admin/pricing-rules/${id}/homepage-display`,
      method: 'put',
      params: {enabled}
    })
  },

  // 切换首页推荐：query enabled=true|false（最多1个，且需先开启首页展示）
  updateHomepageRecommend(id, enabled) {
    return request({
      url: `/api/v1/admin/pricing-rules/${id}/homepage-recommend`,
      method: 'put',
      params: {enabled}
    })
  },

  // 计算折扣率：currentPrice、originalPrice
  calculateDiscountRate(params) {
    return request({
      url: '/api/v1/admin/pricing-rules/discount-rate',
      method: 'get',
      params
    })
  },
  // 获取折扣信息
  getCertificationDiscount(params) {
    return request({
      url: '/api/v1/admin/pricing-rules/getCertificationDiscount',
      method: 'get',
      params
    })
  },
  updateCertificationDiscount(data) {
    return request({
      url: '/api/v1/admin/pricing-rules/certificationDiscount',
      method: 'post',
      data
    })
  },
  getUpdateDiscountLog(params) {
    return request({
      url: '/api/v1/admin/pricing-rules/discountLog',
      method: 'get',
      params
    })
  },


}

// 运维管理相关API
export const maintenanceApi = {
  // 获取运维管理列表
  getMaintenanceList(params) {
    return request({
      url: '/api/v1/admin/ops-devices',
      method: 'get',
      params
    })
  },
  
  // 获取设备维护记录
  getMaintenanceRecords(id, params) {
    return request({
      url: `/api/v1/admin/ops-devices/${id}/maintenance-records`,
      method: 'get',
      params
    })
  },
  
  // 添加维护记录
  addMaintenanceRecord(id, data) {
    return request({
      url: `/api/v1/admin/ops-devices/${id}/maintenance-records`,
      method: 'post',
      data
    })
  },
  
  // 人员下拉（旧）：新增人员等，返回 id / name
  getMaintainerList(params) {
    return request({
      url: '/api/v1/admin/ops-users',
      method: 'get',
      params
    })
  },

  // 运维负责人下拉（新）：按 ops:device 权限筛选，返回 userId / realName
  getOpsDeviceUserList() {
    return request({
      url: '/api/v1/admin/ops-users/list',
      method: 'get'
    })
  }
}

// OQC设备测试相关API
export const oqcDeviceApi = {
  // 启动设备测试
  startDevice(deviceId) {
    return request({
      url: `/api/v1/ops/oqc/device/${deviceId}/start`,
      method: 'post'
    })
  },
  
  // 结束设备测试
  stopDevice(deviceId, orderNo) {
    return request({
      url: `/api/v1/ops/oqc/device/${deviceId}/stop`,
      method: 'post',
      params: { orderNo }
    })
  }
}

// 登录相关API
export const authApi = {
  // 用户登录
  login(data) {
    return request({
      url: '/api/v1/admin/auth/login',
      method: 'post',
      data
    })
  },
  
  // 用户登出
  logout() {
    return request({
      url: '/api/v1/admin/auth/logout',
      method: 'post'
    })
  },
  
  // 获取当前用户信息 - 文档中没有找到，暂时保留
  getUserInfo() {
    return request({
      url: '/api/v1/admin/auth/getOauthInfo',
      method: 'get'
    })
  }
}

// 账户管理相关API（使用管理员账号管理接口）
export const accountApi = {
  getAccountList(params) {
    return request({
      url: '/api/v1/admin/admin-users',
      method: 'get',
      params
    })
  },
  createAccount(data) {
    return request({
      url: '/api/v1/admin/admin-users',
      method: 'post',
      data
    })
  },
  updateAccount(id, data) {
    return request({
      url: `/api/v1/admin/admin-users/${id}`,
      method: 'put',
      data
    })
  },
  deleteAccount(id) {
    return request({
      url: `/api/v1/admin/admin-users/${id}`,
      method: 'delete'
    })
  },
  updateAccountStatus(id, data) {
    return request({
      url: `/api/v1/admin/admin-users/${id}/status`,
      method: 'put',
      data
    })
  },
  resetPassword(id, data) {
    return request({
      url: `/api/v1/admin/admin-users/${id}/password`,
      method: 'put',
      data
    })
  },
  getRoleOptions() {
    return request({
      url: '/api/v1/admin/roles/options',
      method: 'get'
    })
  },
  getCompanyOptions() {
    return request({
      url: '/api/v1/admin/company/all',
      method: 'get'
    })
  }
}

// 企业管理相关API
export const enterpriseApi = {
  getEnterpriseList(params) {
    return request({
      url: '/api/v1/admin/company',
      method: 'get',
      params
    })
  },
  getAllEnterpriseList() {
    return request({
      url: '/api/v1/admin/company/all',
      method: 'get'
    })
  },
  createEnterprise(data) {
    return request({
      url: '/api/v1/admin/company',
      method: 'post',
      data
    })
  },
  updateEnterprise(id, data) {
    return request({
      url: `/api/v1/admin/company/${id}`,
      method: 'put',
      data
    })
  },
  deleteEnterprise(id) {
    return request({
      url: `/api/v1/admin/company/${id}`,
      method: 'delete'
    })
  }
}

// 操作日志（仅管理员）
export const operLogApi = {
  // GET /api/v1/admin/oper-logs/list
  // params: pageNum, pageSize, createdAtStart, createdAtEnd, bizModule, bizId
  getOperLogList(params) {
    return request({
      url: '/api/v1/admin/oper-logs/list',
      method: 'get',
      params
    })
  }
}

// 通用API
export const commonApi = {
  // 获取完整的行政区划树
  getFullTree() {
    return request({
      url: '/api/v1/common/regions/tree',
      method: 'get'
    })
  },

  // OSS 上传（单文件），返回 URL 列表
  // POST /api/v1/common/oss/upload?bizType=common
  uploadFiles(bizType, file) {
    const formData = new FormData()
    formData.append('files', file)
    return request({
      url: '/api/v1/common/oss/upload',
      method: 'post',
      params: { bizType },
      data: formData,
      timeout: 60000
    })
  }
}

// 运营商管理 — 对齐 /api/v1/admin/biz-operator
// 字段：bizOperatorName, level(1|2), parentId, shareRatio(0~100), parentShareRatio,
//       independentSettle, settleCycle(MONTHLY|NATURE_QUARTERLY|QUARTERLY), bankAccount, bankName, bankBranch, smallTaxpayer
export const bizOperatorApi = {
  // GET /api/v1/admin/biz-operator?pageNum&pageSize&level&bizOperatorName&parentId
  getList(params) {
    return request({
      url: '/api/v1/admin/biz-operator',
      method: 'get',
      params
    })
  },
  // GET /api/v1/admin/biz-operator/list  下拉（一/二级合并，带数据隔离，无 page 权限）
  getDropdownList() {
    return request({
      url: '/api/v1/admin/biz-operator/list',
      method: 'get'
    })
  },
  // GET /api/v1/admin/biz-operator/options?level=&parentId=
  getOptions(params) {
    return request({
      url: '/api/v1/admin/biz-operator/options',
      method: 'get',
      params
    })
  },
  // POST /api/v1/admin/biz-operator  body: BizOperatorCreateDTO
  create(data) {
    return request({
      url: '/api/v1/admin/biz-operator',
      method: 'post',
      data
    })
  },
  // PUT /api/v1/admin/biz-operator/{id}  body: BizOperatorUpdateDTO（无 level）
  update(id, data) {
    return request({
      url: `/api/v1/admin/biz-operator/${id}`,
      method: 'put',
      data
    })
  },
  // DELETE /api/v1/admin/biz-operator/{id}
  remove(id) {
    return request({
      url: `/api/v1/admin/biz-operator/${id}`,
      method: 'delete'
    })
  }
}

// 站点管理
export const siteApi = {
  // GET /api/v1/admin/site
  getList(params) {
    return request({
      url: '/api/v1/admin/site',
      method: 'get',
      params
    })
  },
  // POST /api/v1/admin/site
  create(data) {
    return request({
      url: '/api/v1/admin/site',
      method: 'post',
      data
    })
  },
  // PUT /api/v1/admin/site/{id}
  update(id, data) {
    return request({
      url: `/api/v1/admin/site/${id}`,
      method: 'put',
      data
    })
  },
  // DELETE /api/v1/admin/site/{id}
  remove(id) {
    return request({
      url: `/api/v1/admin/site/${id}`,
      method: 'delete'
    })
  },
  // GET /api/v1/admin/site/{id}/devices
  getDevices(id, params) {
    return request({
      url: `/api/v1/admin/site/${id}/devices`,
      method: 'get',
      params
    })
  },
  // GET /api/v1/admin/site/list 站点下拉
  getSiteOptions() {
    return request({
      url: '/api/v1/admin/site/list',
      method: 'get'
    })
  },
  // GET /api/v1/admin/site/unbound-devices
  getUnboundDevices(params) {
    return request({
      url: '/api/v1/admin/site/unbound-devices',
      method: 'get',
      params
    })
  },
  // POST /api/v1/admin/site/{id}/devices
  bindDevices(id, data) {
    return request({
      url: `/api/v1/admin/site/${id}/devices`,
      method: 'post',
      data
    })
  },
  // GET /api/v1/admin/site/aixuanba/list 爱选吧场地，placeName 为空查全部
  listAixuanbaPlaces(params) {
    return request({
      url: '/api/v1/admin/site/aixuanba/list',
      method: 'get',
      params
    })
  }
}

// 数据看板-整体看板 — 对齐 /api/v1/admin/data-board（菜单权限 dashboard:overall）
// 页面级筛选 DataBoardQueryDTO: provinceCode, cityCode, bizOperatorId, siteId, startDate, endDate
// 图表区追加 granularity: DAY|WEEK|MONTH|YEAR（仅决定横坐标分桶，时间范围始终由起止日期决定）
// 排行榜再追加 sortKey（见各榜白名单）
const DATA_BOARD_BASE = '/api/v1/admin/data-board'

function dataBoardGet(path, params) {
  return request({
    url: `${DATA_BOARD_BASE}${path}`,
    method: 'get',
    params
  })
}

export const dataBoardApi = {
  // ---- 全局过滤（排除语义：保存的是要从统计中剔除的对象）----
  // GET /filter-candidates?type=USER|DEVICE|SITE|OPERATOR&keyword= 关键词为空不返回列表，限 50 条
  getFilterCandidates(type, keyword) {
    return dataBoardGet('/filter-candidates', { type, keyword })
  },
  // GET /filter-settings 当前账号已保存的排除项回显
  getFilterSettings() {
    return dataBoardGet('/filter-settings')
  },
  // PUT /filter-settings 全量替换，某维度传空数组=该维度不排除
  saveFilterSettings(data) {
    return request({
      url: `${DATA_BOARD_BASE}/filter-settings`,
      method: 'put',
      data
    })
  },

  // ---- 数据卡片 ----
  getDeviceStats(params) {
    return dataBoardGet('/device-stats', params)
  },
  getUserStats(params) {
    return dataBoardGet('/user-stats', params)
  },
  getOperatorSiteStats(params) {
    return dataBoardGet('/operator-site-stats', params)
  },

  // ---- 订单数据行 ----
  getOrderOverallStats(params) {
    return dataBoardGet('/order-overall-stats', params)
  },
  getStartOrderStats(params) {
    return dataBoardGet('/start-order-stats', params)
  },
  getRechargeOrderStats(params) {
    return dataBoardGet('/recharge-order-stats', params)
  },

  // ---- 赠送订单数据行（统一返回 GiftMetric）----
  getGiftTotalStats(params) {
    return dataBoardGet('/gift-total-stats', params)
  },
  getGiftNewUserStats(params) {
    return dataBoardGet('/gift-new-user-stats', params)
  },
  getGiftInviteStats(params) {
    return dataBoardGet('/gift-invite-stats', params)
  },
  getGiftAdminStats(params) {
    return dataBoardGet('/gift-admin-stats', params)
  },
  getGiftDailyFirstStats(params) {
    return dataBoardGet('/gift-daily-first-stats', params)
  },

  // ---- 图表 ----
  // 固定返回 24 个点：x=0:00~23:00，y=启动订单数
  getUsageFrequency(params) {
    return dataBoardGet('/usage-frequency', params)
  },
  // tab: PACKAGE_SALES-套餐销售额(多系列) / START_ORDER-启动订单金额(单系列)
  getBusinessTrend(tab, params) {
    return dataBoardGet('/business-trend', { ...params, tab })
  },
  // 按注册分桶（YEAR→按月，其余→按天），同期使用/付费口径
  getWeeklyCohort(params) {
    return dataBoardGet('/weekly-cohort', params)
  },

  // ---- 排行榜 TOP10 ----
  // sortKey: TOTAL_DURATION | ORDER_COUNT | AVG_DEVICE_DURATION
  getSiteRank(params) {
    return dataBoardGet('/site-rank', params)
  },
  // sortKey: TOTAL_DURATION | ORDER_COUNT | AVG_ORDER_DURATION
  getDeviceRank(params) {
    return dataBoardGet('/device-rank', params)
  },
  // sortKey: TOTAL_DURATION | ORDER_COUNT
  getUserRank(params) {
    return dataBoardGet('/user-rank', params)
  }
}

// 运营商对账管理（账单）
export const billApi = {
  // GET /api/v1/admin/bill/page
  // params: pageNum, pageSize, operatorName, status
  getBillPage(params) {
    return request({
      url: '/api/v1/admin/bill/page',
      method: 'get',
      params
    })
  },

  // POST /api/v1/admin/bill  结算：{ id, invoiceUrl, receiptUrl }
  settle(data) {
    return request({
      url: '/api/v1/admin/bill',
      method: 'post',
      data
    })
  }
}
